import { useState, useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import axiosInstance from '../../api/axiosInstance';

// Full-screen, login-gated product catalogue (view-only — no PDF, no download).
// The HTML is fetched from the [Authorize] SalesKitController (so it's never
// publicly reachable) and rendered in a sandboxed iframe via srcDoc. The cable
// video is referenced as __ASSETBASE__/saleskit/* and resolved to this origin.
export default function ProductCatalogue() {
    const [html, setHtml] = useState(null);
    const [error, setError] = useState('');

    useEffect(() => {
        axiosInstance
            .get('/SalesKit/ProductCatalogue', {
                responseType: 'text',
                params: { v: Date.now() },            // cache-bust: always fetch the latest
                headers: { 'Cache-Control': 'no-cache' },
            })
            .then(res => {
                const raw = typeof res.data === 'string' ? res.data : '';
                setHtml(raw.replace(/__ASSETBASE__/g, window.location.origin));
            })
            .catch(() => setError('Unable to load the product catalogue. Please make sure you are logged in.'));
    }, []);

    if (error) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', p: 3 }}>
                <Typography sx={{ fontFamily: "'Poppins', sans-serif", color: '#64748B' }}>{error}</Typography>
            </Box>
        );
    }
    if (html == null) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }
    return (
        <iframe
            title="Astern Product Catalogue"
            srcDoc={html}
            style={{ position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 'none' }}
        />
    );
}
